const DEFAULT_MAPPING_ENTRY = {
  status: 'idle',
  document: null,
  error: null,
};

export const selectSavedSalesChannelMappingState = (state, salesChannelId) => {
  if (!salesChannelId) return DEFAULT_MAPPING_ENTRY;
  return state.salesChannelMappings?.byId?.[salesChannelId] || DEFAULT_MAPPING_ENTRY;
};
